import { Chip, Stack } from "@mui/material";
import { Person, Visibility } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { isViewOnly } from "../utils/permissions";

// "Owner: …" on items someone else owns, and "View only" when the signed-in
// user can't change them (backend canModify): they may still run and clone.
export default function OwnerBadge({ item, size = "small", sx }) {
	const me = useSelector((s) => s.auth.user);
	if (!item) return null;
	const othersItem = item.userId && me?.id && item.userId !== me.id;
	const viewOnly = isViewOnly(item);
	if (!othersItem && !viewOnly) return null;
	return (
		<Stack direction="row" spacing={0.5} sx={{ flexWrap: "wrap", ...sx }}>
			{othersItem && item.ownerName && (
				<Chip size={size} variant="outlined" icon={<Person />} label={`Owner: ${item.ownerName}`} />
			)}
			{viewOnly && (
				<Chip size={size} variant="outlined" color="info" icon={<Visibility />} label="View only" />
			)}
		</Stack>
	);
}
